const ShieldCheck = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    <path d="m9 12 2 2 4-4"/>
  </svg>
);

const Lock = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="11" width="16" height="10" rx="2"/>
    <path d="M8 11V7a4 4 0 0 1 8 0v4"/>
    <circle cx="12" cy="16" r="1.2" fill="currentColor"/>
  </svg>
);

const ClockExpire = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9"/>
    <path d="M12 7v5l3 2"/>
  </svg>
);

const Tooth = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M7.5 2.6c-2.2.4-3.7 2-3.7 4.3 0 1.6.5 3.1 1.1 5.6.5 2.1.5 3.4 1 5.6.5 2 1.4 3.5 2.5 3.5.9 0 1.3-.8 1.7-2.2.4-1.5.6-3.5 1.9-3.5s1.5 2 1.9 3.5c.4 1.4.8 2.2 1.7 2.2 1.1 0 2-1.5 2.5-3.5.5-2.2.5-3.5 1-5.6.6-2.5 1.1-4 1.1-5.6 0-2.3-1.5-3.9-3.7-4.3-2-.4-3.4.7-4.5.7s-2.5-1.1-4.5-.7Z"/>
  </svg>
);

const BADGES = [
  { icon: ShieldCheck, label: 'HIPAA-compliant', sub: 'BAA included' },
  { icon: Lock,        label: 'AES-256 encrypted', sub: 'In transit & at rest' },
  { icon: ClockExpire, label: 'Auto-expires', sub: '7 days, then deleted' },
  { icon: Tooth,       label: 'Free for dental', sub: 'Built by a dentist' },
];

export default function TrustBadges() {
  return (
    <ul className="trust-badges" aria-label="Security and compliance">
      {BADGES.map(({ icon: Icon, label, sub }) => (
        <li key={label}>
          <span className="trust-icon"><Icon /></span>
          <span className="trust-text">
            <strong>{label}</strong>
            <em>{sub}</em>
          </span>
        </li>
      ))}
    </ul>
  );
}
